// extracted by mini-css-extract-plugin
export default {"cta":"xG-z","disabled":"yG-z"};